/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import NegoActionStepper from "../../../../components/Stepper/NegoActionStepper";
import PreparationOverview from "./preparationOverview";
import FinalizationOverview from "./finalizationOverview";
import NegotiationRoundOverview from "./negotiationRoundOverview";
import NavigationButtonsForOverview from "./navigationButtonsForOverview";
import PowerPositionCard from "../../../../components/PowerPositionCard/powerPositionCard";
import SuperiorImg from "../../../../assets/Images/Mighty.png";
import DependentPartnerImg from "../../../../assets/Images/DependentPartners.png";
import IndependentPartnerImg from "../../../../assets/Images/IndependentPartners.png";
import InferiorImg from "../../../../assets/Images/Weak.png";
import RationalistImg from "../../../../assets/Images/RationalistImg.png";
import PerformerImg from "../../../../assets/Images/PerformerImg.png";
import HarmonizerImg from "../../../../assets/Images/HarmonizerImg.png";
import OptimizerImg from "../../../../assets/Images/OptimizerImg.png";
import SaleRepClassificationCard from "../../../../components/SalesRepClassificationCard/salesRepClassifictationCard";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../../../../redux/Reducer";
import { getNegotiationTileDataAction, saveDetailedNegotiationOverviewAction } from "../../../../redux/Action/Action";
import { useNavigate } from "react-router-dom";
import {
  POST_SAVE_FORM_DETAILS,
  SET_EXIT_STATUS_DETIALED_OVERVIEW,
  SET_IS_DATA_UPDATED,
} from "../../../../redux/Action/actionTypes";
import ToastNotifier from "../../../../components/ToastNotifier/toastNotifier";
import { Spinner } from "reactstrap";
import EditModalForNegotiation from "./Edit Detailed Negotiation/editModalForNegotiation";
const DetailedOverview: React.FC = () => {
  const [currentStep, setCurrentStep] = useState<number>(0);
  const [totalSteps, setTotalSteps] = useState<number>(3);
  const [powerPositionType, setPowerPositionType] = useState<string>("");
  const [salesRepType, setSalesRepType] = useState<string>("");
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [isEditStatus, setIsEditStatus] = useState<string>("")
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isLoader = useSelector(
    (state: RootState) => state.toastMessageReducer.loading
  );
  const isDataUpdated = useSelector(
    (state: RootState) => state.dashboardData.isDataUpdated
  );
  const isExited = useSelector(
    (state: RootState) => state.dashboardData.isExited
  );
  const [isEditDisabled, setIsEditDisabled] = useState(false)
  const negotiationContractData = useSelector(
    (state: RootState) => state.dashboardData.detailedOverviewData
  );
  const totalAddedRounds = useSelector((state: RootState) => state.dashboardData?.detailedOverviewData?.planNegotiationActions?.negotiationRoundsDetails)
  const basicDetailsData = useSelector(
    (state: RootState) => state.basicDetails.basicDetailsData
  );
  const powerPositionDetails = useSelector(
    (state: RootState) => state.powerPosition
  );
  const TargetValueData = useSelector(
    (state: RootState) => state.TargetValue.TargetValueData
  );
  const salesRepClassificationData = useSelector(
    (state: RootState) => state.salesRepClassification
  );
  const isFormUpdate = useSelector(
    (state: RootState) => state.basicDetails.formState
  );
  const existingNegotiationActions = useSelector((state: RootState) => state.selectedActionTiles.SelectedActionTilesData)
  const contractStatus = useSelector(
    (state: RootState) => state.dashboardData.contractStatus
  );

  // stepper change handler 
  const stepChangeHandler = (nextStep: number) => {
    setCurrentStep(nextStep);
  };

  // backward step change handler 
  const backwardStepChangehandler = () => {
    setCurrentStep((prev) => prev - 1);
  };

  // adding round step handler 
  const addStepHandler = (nextStep: number) => {
    let RoundName = "Round" + nextStep
    const updatedPlanNegotiationActions = {
      ...existingNegotiationActions,
      [RoundName]: []
    };
    const updatedTargetValueData = {
      ...TargetValueData,
      rounds: nextStep
    }
    dispatch({
      type: POST_SAVE_FORM_DETAILS,
      payload: {
        isFormUpdate,
        basicDetailsData,
        salesRepClassificationData,
        powerPositionDetails,
        TargetValueData: updatedTargetValueData,
        PlanNegotiationActions: updatedPlanNegotiationActions,
        IsSavedForLater: false,
      },
      meta: {
        onSuccess: () => {
        }
      }
    });
    setTotalSteps(totalSteps + 1);
    setCurrentStep(nextStep);
  }

  // power position card content handler for different power position
  const userContentHandler = (userName: string = "Superior") => {
    switch (userName) {
      case "Superior":
        return (
          <ul>
            <li>
              <b>Supplier is more dependant</b> on you as a client than you are on the supplier.
            </li>
            <li>
              Your objective must be <b>very ambitious</b> and should beat the
              price change of the supplier’s input products (e.g. precursors)
              significantly
            </li>
          </ul>
        );
      case "Dependent":
        return (
          <ul>
            <li>
              Both you and the supplier are <b>dependant on each other.</b>
            </li>
            <li>
              Your objective must be <b>ambitious</b> and should{" "}
              <b>beat the price change</b> of the supplier’s (e.g. precursors)
            </li>
          </ul>
        );
      case "Independent":
        return (
          <ul>
            <li>Neither you nor the supplier are dependent on each other</li>
            <li>
              Your objective should <b>beat the price change</b> of the
              supplier’s input products (e.g. precursors), without any price
              premium for the supplier
            </li>
          </ul>
        );
      case "Inferior":
        return (
          <ul>
            <li>
              <b>You are more dependent</b> on the supplier than the supplier is on you.
            </li>
            <li>
              Your objective should be <b>oriented toward the price change</b>{" "}
              of the supplier’s input products (e.g. precursors); negotiating
              results worse than price change must be avoided
            </li>
          </ul>
        );
    }
  };

  // sales rep classification card content handler for different types
  const cardContentHandler = () => {
    switch (salesRepType) {
      case "Rationalist": return [
        "Well prepared",
        "Fact oriented",
        "Proud of product and expertise",
        "In control of his/her emotions",
      ]

      case "Performer": return [
        "Well prepared",
        "Relationship oriented",
        "Knows to adapt",
        "Talks powerful, yet chooses words carefully",
      ]
      case "Harmonizer": return [
        "No detailed preparation",
        "Relationship oriented",
        "Good listener",
        "Takes a moment to think before speaking",
      ]
      case "Optimizer": return [
        "No detailed preparation",
        "Fact oriented",
        "Rather impulsive",
        "Talks spontaneously without much thought",
      ]
      default: return []
    }
  }

  // sales rep classification type sub heading handler 
  const subheadingHandler = () => {
    switch (salesRepType) {
      case "Rationalist": return "“The truth of the story lies in the details”"
      case "Performer": return "“Don’t let anything stop you from reaching your goals”"
      case "Harmonizer": return "“Keep calm to achieve your goals”"
      case "Optimizer": return "“Minimal efforts to achieve given goals”"
      default: return ""
    }
  }

  // save handler after exit the negotiation
  const saveHandler = (status: string) => {
    dispatch(
      saveDetailedNegotiationOverviewAction({
        ...negotiationContractData.planNegotiationActions,
        status: status,
      })
    );
  };

  // close round button handler while closing the round
  const closeRoundHandler = () => {
    dispatch(
      saveDetailedNegotiationOverviewAction({
        roundClose: {
          ...negotiationContractData.planNegotiationActions
        },
        roundCloseStatus: true
      })
    );
  }

  //navigation of application after review negotiation in in-progress negotiation
  useEffect(() => {
    if (isDataUpdated) {
      if (isExited) {
        navigate("/");
        dispatch({ type: SET_EXIT_STATUS_DETIALED_OVERVIEW, payload: false });
      } else {
        navigate("/DocumentOutcome");
      }
      dispatch({ type: SET_IS_DATA_UPDATED, payload: false });
    }
  }, [isDataUpdated]);

  // updating the power position , sales rep type from negotiation get api response
  useEffect(() => {
    if (Object.keys(negotiationContractData).length > 0) {
      setTotalSteps(totalAddedRounds.length);
      setPowerPositionType(
        negotiationContractData.powerPosition.powerPositionTitle
      );
      setSalesRepType(
        negotiationContractData.salesRepClassification
          .salesRepClassificationTitle
      );
    }
  }, [negotiationContractData]);

  // power position card image handler for different power position 
  const powerPositionCardImgHandler = () => {
    switch (powerPositionType) {
      case "Superior":
        return SuperiorImg;
      case "Independent":
        return IndependentPartnerImg;
      case "Dependent":
        return DependentPartnerImg;
      case "Inferior":
        return InferiorImg;
      default:
        return SuperiorImg;
    }
  };

  // sales rep image handler for different sales rep types
  const saleRepImgHandler = () => {
    switch (salesRepType) {
      case "Rationalist":
        return RationalistImg;
      case "Performer":
        return PerformerImg;
      case "Harmonizer":
        return HarmonizerImg;
      case "Optimizer":
        return OptimizerImg;
      default:
        return RationalistImg;
    }
  };

  // css classes handler for different sales rep types
  const saleRepCardColorHandler = () => {
    switch (salesRepType) {
      case "Rationalist":
        return "card1";
      case "Performer":
        return "card2";
      case "Harmonizer":
        return "card3";
      case "Optimizer":
        return "card4";
      default:
        return "card1";
    }
  };

  // css classes handler for different sales rep types descriptions
  const salesRepInfoHandler = () => {
    switch (salesRepType) {
      case "Rationalist":
        return "rationalist-info-background rationalist";
      case "Performer":
        return "performer-info-background performer";
      case "Harmonizer":
        return "harmonizer-info-background harmonizer";
      case "Optimizer":
        return "optimizer-info-background optimizer";
      default:
        return "rationalist-info-background";
    }
  }
  const targetData = negotiationContractData.targetValue

  useEffect(() => {
    if (Object.keys(negotiationContractData).length == 0) {
      navigate('/')
    }
  }, [])
  const editHandler = (status: any) => {
    setIsEdit(true);
    setIsEditStatus(status)
  }
  const toggleHandler = () => {
    setIsEdit(false);
    setIsEditStatus("")
  }

  // disabling the edit option if user closed the round
  useEffect(() => {
    let roundNameText = currentStep == 0 ? "Preparation" : `Round${currentStep}`
    let negotiationStepsData = negotiationContractData?.planNegotiationActions?.negotiationRoundsDetails
    negotiationStepsData?.length > 0 && negotiationStepsData.map((data: any) => {
      if (data?.roundName == roundNameText) {
        setIsEditDisabled(data.isRoundClosed)
      }
    })
    if (currentStep === totalSteps - 1) {
      setIsEditDisabled(false)
    }
  }, [currentStep])

  const basicDetails = negotiationContractData.basicDetails;

  // month name format handler for negotiation date and implementation
  const getMonthName = (monthNumber: number): string => {
    const months = [
      "January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
    ];
    if (monthNumber < 1 || monthNumber > 12) {
      return "--";
    }
    return months[monthNumber - 1];
  }

  const ContractId = useSelector(
    (state: RootState) => state.dashboardData.detailedOverviewData?.planNegotiationActions?.negotiationId
  );
  const fetchUpdatedCards = () => {
    dispatch(
      getNegotiationTileDataAction({
        id: ContractId,
        contractStatus: contractStatus
      })
    );
  }

  // Extracted roundName logic
  let roundName = "";
  if (currentStep === 0) {
    roundName = "Preparation";
  } else if (currentStep === totalSteps - 1) {
    roundName = "Finalization";
  } else {
    roundName = `Round${currentStep}`;
  }

  // Helper: Basic Details Section
  const renderBasicDetailsSection = () => (
    <div>
      <div className="neotiation-overview-basic-details-header">
        Basic Details :
      </div>
      <div className="negotiation-basic-details-box">
        <svg xmlns="http://www.w3.org/2000/svg" onClick={isEditDisabled ? () => { } : () => editHandler("Basic Details")} width="16" height="16" fill={isEditDisabled ? "gray" : "currentColor"} className="bi bi-pencil negotiation-overview-edit" viewBox="0 0 16 16">
          <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.5.5 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11z" />
        </svg>
        <div className="row">
          <div className="col-6">
            <ul>
              <li>
                <div className="basic-details-field-box">
                  <div className="basic-details-field-name">Negotiation Name :</div>
                  <div className="basic-details-field-value">{basicDetails?.name ? basicDetails.name : '--'}</div>
                </div>
              </li>
              <li>
                <div className="basic-details-field-box">
                  <div className="basic-details-field-name">Supplier :</div>
                  <div className="basic-details-field-value">{basicDetails?.supplierName ? basicDetails.supplierName : '--'}</div>
                </div>
              </li>
              <li>
                <div className="basic-details-field-box">
                  <div className="basic-details-field-name">Sales Rep Lead:</div>
                  <div className="basic-details-field-value">{basicDetails?.salesRepLeadName ? basicDetails.salesRepLeadName : '--'}</div>
                </div>
              </li>
              <li>
                <div className="basic-details-field-box">
                  <div className="basic-details-field-name">Category Name :</div>
                  <div className="basic-details-field-value">{basicDetails?.categoryName ? basicDetails.categoryName : '--'}</div>
                </div>
              </li>
            </ul>
          </div>
          <div className="col-6">
            <ul>
              <li>
                <div className="basic-details-field-box">
                  <div className="basic-details-field-name">Relevant Spend :</div>
                  <div className="basic-details-field-value">{basicDetails?.formatedRelevantSpend ? basicDetails.formatedRelevantSpend : '--'}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="14"
                      height="14"
                      fill="#000"
                      className="bi bi-currency-euro close-negotiation-amount-logo"
                      viewBox="0 0 16 16"
                    >
                      <path d="M4 9.42h1.063C5.4 12.323 7.317 14 10.34 14c.622 0 1.167-.068 1.659-.185v-1.3c-.484.119-1.045.17-1.659.17-2.1 0-3.455-1.198-3.775-3.264h4.017v-.928H6.497v-.936q-.002-.165.008-.329h4.078v-.927H6.618c.388-1.898 1.719-2.985 3.723-2.985.614 0 1.175.05 1.659.177V2.194A6.6 6.6 0 0 0 10.341 2c-2.928 0-4.82 1.569-5.244 4.3H4v.928h1.01v1.265H4v.928z" />
                    </svg>
                  </div>
                </div>
              </li>
              <li>
                <div className="basic-details-field-box">
                  <div className="basic-details-field-name">Validity :</div>
                  <div className="basic-details-field-value">{basicDetails?.validityPeriod ? `${basicDetails.validityPeriod} months` : '--'}</div>
                </div>
              </li>
              <li>
                <div className="basic-details-field-box">
                  <div className="basic-details-field-name">Negotiation Date :</div>
                  <div className="basic-details-field-value">{getMonthName(basicDetails?.negotiationDateMonth) ? getMonthName(basicDetails.negotiationDateMonth) : '--'} {basicDetails?.negotiationDateYear ? basicDetails.negotiationDateYear : '--'}</div>
                </div>
              </li>
              <li>
                <div className="basic-details-field-box">
                  <div className="basic-details-field-name">Negotiation implementation :</div>
                  <div className="basic-details-field-value">{getMonthName(basicDetails?.negotiationImplementationMonth) ? getMonthName(basicDetails.negotiationImplementationMonth) : '--'} {basicDetails?.negotiationImplementationYear ? basicDetails.negotiationImplementationYear : '--'}</div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );

  // Helper: Power Position and Sales Rep
  const renderPowerPositionAndSalesRepSection = () => (
    <div className="row">
      <div className="col-3 padding-left-style">
        <span className="detailed-overview-power-position-heading">
          Power Position
        </span>
        <PowerPositionCard
          userName={powerPositionType}
          userContent={<>{userContentHandler(powerPositionType)}</>}
          userImage={powerPositionCardImgHandler()}
          cardSelected={powerPositionType}
          cardHandler={() => { }}
          isEditMode={true}
          isEditDisabled={isEditDisabled}
          editHandler={isEditDisabled ? () => { } : () => editHandler("Power Position")}
        />
      </div>
      <div className="col-3 padding-left-style">
        <span className="detailed-overview-sales-rep-heading">
          Sales rep's Negotiation type
        </span>
        {salesRepType === null || salesRepType === "" ?
          <div className="sales-rep-not-selected-container">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" onClick={isEditDisabled ? () => { } : () => editHandler("Sales Rep Classification")} fill={isEditDisabled ? "gray" : "currentColor"} className="bi bi-pencil negotiation-overview-edit" viewBox="0 0 16 16">
              <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.5.5 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11z" />
            </svg>
            <div className="sales-rep-content">
              <div className="sales-rep-content-alignment">
                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="#c50022" className="bi bi-exclamation-triangle-fill" viewBox="0 0 16 16">
                  <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5m.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2" />
                </svg>
              </div>
              <div className="sales-rep-content-text">Sales rep classification type is not selected. Please update it using Edit option.</div>
            </div>
          </div>
          :
          <SaleRepClassificationCard
            classList={saleRepCardColorHandler()}
            cardImg={saleRepImgHandler()}
            cardHeading={salesRepType}
            subHeading={subheadingHandler()}
            cardContent={cardContentHandler()}
            cardSelected={salesRepType}
            cardHandler={() => { }}
            isDetailedView={true}
            isEditMode={true}
            isEditDisabled={isEditDisabled}
            editHandler={isEditDisabled ? () => { } : () => editHandler("Sales Rep Classification")}
          />}
      </div>
      <div className="col-6 padding-left-style">
        <div className={`sales-rep-info-container-${salesRepType?.toLocaleLowerCase()} ${salesRepInfoHandler()}`}>
          {negotiationContractData?.salesRepClassification?.salesRepClassificationDetailDescription ?
            <div
              dangerouslySetInnerHTML={{
                __html: negotiationContractData.salesRepClassification.salesRepClassificationDetailDescription,
              }}
            /> : ""}
        </div>
      </div>
    </div>
  );

  // Helper: Target Value Section
  const renderTargetValueSection = () => (
    <div >
      <div className="row">
        <div className="col-6">
          <div className="negotiation-target-header">Primary Negotiation Target :</div>
        </div>
        <div className="col-6">
          <div className="negotiation-target-header">Secondary Negotiation Target :</div>
        </div>
      </div>
      <div className="negotiation-overview-target-box">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" onClick={isEditDisabled ? () => { } : () => editHandler("Target Value")} fill={isEditDisabled ? "gray" : "currentColor"} className="bi bi-pencil negotiation-overview-edit" viewBox="0 0 16 16">
          <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.5.5 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11z" />
        </svg>
        <div className="row">
          <div className="col-6 padding-left-style">
            <div className="negotiation-target-box">
              <ul>
                <li>
                  <span>Expected pre cursor cost change</span> : {targetData?.precursorCostChanges != null ? `${targetData?.precursorCostChanges} %` : '--'}
                </li>
                <li>
                  <span>Negotiation Target</span> : {targetData?.negotiationTarget != null ? `${targetData?.negotiationTarget} %` : '--'}
                </li>
                <li>
                  <span>Stop limit</span> : {targetData?.stopLimit != null ? `${targetData?.stopLimit} %` : '--'}
                </li>
                <li>
                  <span>Go-In position</span> : {targetData?.goinPosition != null ? `${targetData?.goinPosition} %` : '--'}
                </li>
              </ul>
            </div>
          </div>
          <div className="col-6 padding-left-style">
            <div className="secondary-negotiation-target-box">
              <ul>
                <li>
                  <span>Payment terms</span> : {targetData?.paymentTerms ? targetData.paymentTerms : '--'}
                </li>
                <li>
                  <span>Inco terms</span> : {targetData?.incoTerms ? targetData.incoTerms : '--'}
                </li>
                <li>
                  <span>Local stock</span> : {targetData?.localStock ? targetData.localStock : '--'}
                </li>
              </ul>
            </div>

          </div>
        </div>
      </div>
      <div style={{ display: currentStep === 0 ? "block" : "none" }}>
        <PreparationOverview currentStep={currentStep} isEditDisabled={isEditDisabled} />
      </div>
      <div
        style={{
          display:
            currentStep !== 0 && currentStep <= totalSteps - 2
              ? "block"
              : "none",
        }}
      >
        <NegotiationRoundOverview
          roundNumber={currentStep}
          roundName={`Round${currentStep}`}
          isEditDisabled={isEditDisabled}
        />
      </div>
      <div
        style={{ display: currentStep === totalSteps - 1 ? "block" : "none" }}
      >
        <FinalizationOverview currentStep={currentStep} isEditDisabled={isEditDisabled} />
      </div>
    </div>
  );



  // --- Main simplified render
  return (
    <>
      <NegoActionStepper
        currentStep={currentStep}
        totalSteps={totalSteps}
        goToStep={stepChangeHandler}
      />
      <div className="detailed-overview-container">
        {renderBasicDetailsSection()}
        {renderPowerPositionAndSalesRepSection()}
        {renderTargetValueSection()}
        <NavigationButtonsForOverview
          currentStep={currentStep}
          totalSteps={totalSteps}
          stepChangeHandler={stepChangeHandler}
          addStepHandler={addStepHandler}
          roundName={roundName}
          backwardStepChangehandler={backwardStepChangehandler}
          saveHandler={saveHandler}
          fetchUpdatedCards={fetchUpdatedCards}
          closeRoundHandler={closeRoundHandler}
        />
      </div>
      <ToastNotifier />
      {isLoader && (
        <div className="spinner-overlay">
          <Spinner className="spinner-style"></Spinner>
        </div>
      )}
      <EditModalForNegotiation
        isOpen={isEdit}
        toggle={toggleHandler}
        isEditStatus={isEditStatus}
        id={negotiationContractData?.planNegotiationActions?.negotiationId}
        contractStatus={contractStatus}
      />
    </>
  );
};

export default DetailedOverview;
